// @flow
import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

const messages: { [key: string]: MessageDescriptor } = defineMessages({
  completedFormMessage: {
    id: 'boxFileRequest.completedForm.message',
    description: 'Message for completed forms',
    defaultMessage: 'Success! Your files have been submitted.',
  },
  completedFormMessageSingle: {
    id: 'boxFileRequest.completedForm.messageSingle',
    description: 'Message for completed forms containing a single file',
    defaultMessage: 'Success! Your file has been submitted.',
  },
  goToMyAccount: {
    id: 'boxFileRequest.completedForm.goToMyAccount',
    description: 'Button label for Go to My Account',
    defaultMessage: 'Go to My Account',
  },
});

export default messages;
